import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import logoLight from "../../assets/images/optimize_logo light.png";
import logoDark  from "../../assets/images/optimize_logo dark.png";
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
import { usePageGrid } from "../../context/PageGridContext";

const Header = (props) => {
  const companyId = localStorage.getItem("companyid");
  const role      = localStorage.getItem("role");
  const isAdmin   = role === "admin";

  const [editOn, setEditOn] = useState(false);
  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState({ light: "", dark: "" });
  const ctx = usePageGrid();

  /* ── fetch company logos ─────────────────────────────────────── */
  useEffect(() => {
    async function fetchLogos() {
      try {
        const res  = await fetch(`https://api.hanoch.in/api/company-logo-getbyid/?company_id=${companyId}`);
        const data = await res.json();
        if (data?.logos?.length >= 2) {
          localStorage.setItem("company_logo_light", data.logos[0]);
          localStorage.setItem("company_logo_dark",  data.logos[1]);
          setSelectedCompanyLogo({ light: data.logos[0], dark: data.logos[1] });
        }
      } catch(e) { console.error("Logo fetch error:", e); }
    }
    fetchLogos();
  }, []);

  useEffect(() => {
    const light = localStorage.getItem("company_logo_light");
    const dark  = localStorage.getItem("company_logo_dark");
    if (light && dark) setSelectedCompanyLogo({ light, dark });
  }, []);

  /* ── sidebar toggle ──────────────────────────────────────────── */
  function tToggle() {
    const body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  /* ── fullscreen ──────────────────────────────────────────────── */
  function toggleFullscreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  }

  /* ── Edit Layout button handler ──────────────────────────────── */
  const handleEditLayout = () => {
    ctx?.triggerEdit();
    setEditOn(e => !e);
  };

  /* ── Widgets button handler ──────────────────────────────────── */
  const handleWidgets = () => {
    ctx?.triggerWidgets();
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className="pb-2 pt-1">
        <div className="navbar-header">

          {/* ── Left: hamburger + logo ──────────────────────────── */}
          <div className="d-flex align-items-center">
            <div className="py-2 px-1">
              <button
                type="button"
                className="btn btn-sm py-3 font-size-24 header-item waves-effect"
                id="vertical-menu-btn"
                onClick={tToggle}
              >
                <i className="ri-menu-2-line align-middle" />
              </button>
            </div>
            <div className="navbar p-0 justify-content-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-lg">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.light || logoDark}`} alt="logo" height="72" />
                </span>
                <span className="logo-sm">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.light || logoDark}`} alt="logo-sm" height="72" />
                </span>
              </Link>
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.dark || logoLight}`} alt="logo-sm-light" height="72" />
                </span>
                <span className="logo-lg">
                  <img src={`https://api.hanoch.in/${selectedCompanyLogo.dark || logoLight}`} alt="logo-light" height="72" />
                </span>
              </Link>
            </div>
          </div>

          {/* ── Right: admin controls + profile + settings ─────── */}
          <div className="d-flex align-items-center gap-2">

            {/* Admin-only: Edit Layout + Widgets buttons */}
            {isAdmin && (
              <div className="d-flex align-items-center gap-2 me-2" style={{ borderRight: "1px solid #e9ecef", paddingRight: "12px" }}>
                <button
                  type="button"
                  className={`btn btn-sm ${editOn ? "btn-success" : "btn-outline-secondary"}`}
                  style={{ fontSize: 12, padding: "4px 12px", display: "flex", alignItems: "center", gap: 5 }}
                  onClick={handleEditLayout}
                  title="Toggle edit mode for current page layout"
                >
                  <i className={`mdi ${editOn ? "mdi-content-save" : "mdi-pencil-ruler"}`} style={{ fontSize: 14 }} />
                  {editOn ? "Save Layout" : "Edit Layout"}
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  style={{ fontSize: 12, padding: "4px 12px", display: "flex", alignItems: "center", gap: 5 }}
                  onClick={handleWidgets}
                  title="Customize widgets for current page"
                >
                  <i className="mdi mdi-tune" style={{ fontSize: 14 }} />
                  Widgets
                </button>

                {/* Role badge */}
                <span
                  className="badge"
                  style={{ background: "#556ee620", color: "#556ee6", border: "1px solid #556ee640", fontSize: 10, padding: "3px 8px", borderRadius: 20, fontWeight: 600, letterSpacing: 0.5 }}
                >
                  ADMIN
                </span>
              </div>
            )}

            {/* Role badge for non-admins */}
            {/* {!isAdmin && role && (
              <div className="me-2" style={{ borderRight: "1px solid #e9ecef", paddingRight: "12px" }}>
                <span
                  className="badge"
                  style={{ background: "#f8f9fa", color: "#74788d", border: "1px solid #e9ecef", fontSize: 10, padding: "3px 8px", borderRadius: 20, fontWeight: 600, letterSpacing: 0.5, textTransform: "uppercase" }}
                >
                  {role.replace(/_/g, " ")}
                </span>
              </div>
            )} */}

            {/* Fullscreen */}
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button type="button" onClick={toggleFullscreen} className="btn header-item noti-icon" data-toggle="fullscreen">
                <i className="ri-fullscreen-line" />
              </button>
            </div>

            {/* Profile */}
            <ProfileMenu />

            {/* Settings cog (hide for company 5) */}
            {companyId != 5 && (
              <div
                className="dropdown d-inline-block"
                onClick={() => props.showRightSidebarAction(!props.showRightSidebar)}
              >
                <button type="button" className="btn header-item noti-icon right-bar-toggle waves-effect">
                  <i className="mdi mdi-cog" />
                </button>
              </div>
            )}
          </div>

        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
